<template>
  <Preloader v-if="localLoading" />
  <VRow v-else class="h-100">
    <VCol cols="12" class="pt-0 pt-md-2 h-100 d-flex flex-column">
      <PageTitle
        no-border
        tag="h1"
        level="2"
        class="my-5"
      >
        <span class="d-none d-md-inline font-weight-light">
          {{ $t('vacancy') }}: </span>{{ vacancy.title }}
      </PageTitle>
      <VDivider />
      <TestForm
        :vacancy-id="vacancyId"
        @finish="back"
        @goBack="back"
      />
    </VCol>
  </VRow>
</template>

<script>
import Preloader from '@/components/Preloader.vue';
import PageTitle from '@/components/PageTitle.vue';
import TestForm from '@/components/Test/TestForm.vue';
import {
  ref, toRefs, computed, onMounted,
} from '@vue/composition-api';
import Vacancy from '@/orm/models/Vacancy/Vacancy';
import useVacancies from '@/compositions/useVacancies';

export default {
  name: 'VacancyTest',
  components: { TestForm, PageTitle, Preloader },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  setup(props, { root: { $router } }) {
    const { vacancyId } = toRefs(props);
    const { fetchById } = useVacancies();
    const vacancy = computed(() => Vacancy.query().find(vacancyId.value));
    const localLoading = ref(true);

    function back() {
      $router.push({ name: 'vacancy', params: { id: vacancyId.value } });
    }

    onMounted(async () => {
      localLoading.value = true;
      await fetchById(vacancyId.value);
      localLoading.value = false;
    });

    return {
      back,
      localLoading,
      vacancy,
    };
  },
};
</script>

<style scoped lang="scss">
.h-100 {
  height: 100%;
}
</style>

<i18n locale="en" lang="yaml">
  vacancy: Job
</i18n>

<i18n locale="ru" lang="yaml">
  vacancy: Вакансия
</i18n>
